import React, { useEffect } from "react"
import { useFormContext } from "react-hook-form"
import styled from "styled-components"
import PropTypes from "prop-types"

const InputStyle = styled.div`
  margin-bottom: 15px;

  label {
    display: block;
    font-family: system-ui;
    font-size: 0.875rem;
    font-weight: 500;
    margin-bottom: 6px;
  }

  .form-input {
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
    font-family: system-ui;
    font-size: 16px;
    font-weight: 500;
    border-radius: 4px;
    border-width: 1px;
    height: 50px;
  }

  .field-content {
  }

  .input-error {
    border-color: red;
    border-radius: 4px;
  }

  .error-message {
    color: red;
    font-size: 16px;
    font-weight: 700;
    margin-top: 6px;
    display: flex;
    flex-direction: column;
    .icon-close {
      color: red;
    }
    .icon-check {
      color: green;
    }
    span {
      display: flex;
      color: black;
      font-weight: 400;

      div {
        width: 20px;
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 4px;
      }
    }
  }
`

const FormInput = ({
  label,
  name,
  type = "text",
  validate,
  placeholder,
  min,
  max,
}) => {
  const {
    register,
    formState: { errors },
    watch,
    setValue,
  } = useFormContext()

  useEffect(() => {
    switch (type) {
      case "number":
        if (typeof min === "number") {
          if (watch(name) < min) {
            setValue(name, min)
          }
        }

        if (max) {
          if (watch(name) > max) {
            setValue(name, max)
          }
        }

        break
    }
  }, [max, min, name, setValue, type, watch])

  return (
    <InputStyle>
      <label htmlFor={name}>{label}</label>
      <input
        id={name}
        placeholder={placeholder}
        type={type}
        min={min}
        max={max}
        {...register(name, { validate })}
        className={`form-input ${errors[name] ? "input-error" : ""}`}
      />
      {errors[name] && (
        <span
          className="error-message"
          dangerouslySetInnerHTML={{ __html: errors[name].message }}
        ></span>
      )}
    </InputStyle>
  )
}

FormInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  validate: PropTypes.func,
  placeholder: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
}

export default FormInput
